import debounce from 'lodash/debounce'
import { action, computed, observable } from 'mobx'
import { ElementRefStore } from './paginated-hierarchy-items/ElementRefStore'

export class ScrollPositionStore {
  @observable hierarchy = {}
  @observable.ref scrolledNode = null
  @observable scrollTop = 0
  @observable scrollLeft = 0
  /**
   * actualScrollTop: used internally in non hierarchical component
   * to avoid debounce's delay in getting scrollTop
   * currently used in qtyNumberInput
   */
  @observable actualScrollTop = 0

  constructor(public elementRefStore: ElementRefStore) {}

  @action setHierarchy = hierarchy => {
    this.hierarchy = hierarchy
  }

  @computed.struct get scrollIndex() {
    return this.scrollTop === this.scrolledNode?.top - this.scrolledNode?.stickyTop
      ? this.scrolledNode?.index
      : undefined
  }

  @action
  scrollToNode = id => {
    const node = this.elementRefStore.ref?.nodes?.find?.(node => node.id === id)
    if (node) {
      this.updateScrollToNode(node)
      this.scrollTop = node.top - node.stickyTop
    }
  }

  onScroll = scrollData => {
    const { scrollTop, scrollLeft, scrollReason = 'observed' } = scrollData
    this.scrollLeft = scrollLeft
    this.actualScrollTop = scrollTop
    if (scrollReason === 'observed') {
      this.updateScrollToCategory(scrollTop)
    }
  }

  @action
  initScrollToNode = nodes => {
    if (nodes?.root?.children?.length) {
      let leafHierarchyNode = nodes.root.children[0]
      while (nodes[leafHierarchyNode]?.children?.length) {
        leafHierarchyNode = nodes[leafHierarchyNode]?.children[0]
      }
      if (leafHierarchyNode) {
        this.scrollTop = leafHierarchyNode.top - leafHierarchyNode.stickyTop
        this.updateScrollToNode(leafHierarchyNode)
      }
    }
  }

  @action
  updateScrollToNode = scrollToNode => {
    this.scrolledNode = scrollToNode
  }

  @action
  updateScrollToCategory = debounce(
    (passedScrollTop?) => {
      const nodes = this.elementRefStore.ref?.nodes?.slice?.(1) || []
      const scrollTop = passedScrollTop || this.elementRefStore.ref?.state?.scrollTop
      // 0th index is root, ignoring that
      // 1st has parent root
      if (nodes?.length) {
        const selectedNode = nodes.find((item: any) => {
          if (item) {
            const itemStart = item.top - item.stickyTop
            let itemEnd = itemStart + item.height
            return itemStart <= scrollTop && itemEnd >= scrollTop
          }
          return false
        })

        if (selectedNode?.id) {
          if (selectedNode.id !== this.scrolledNode?.id) {
            this.scrollTop = passedScrollTop
            this.updateScrollToNode(selectedNode)
          }
        } else {
          this.initScrollToNode(this.hierarchy)
        }
      }
    },
    200,
    { trailing: true }
  )

  @action
  reset = () => {
    this.hierarchy = {}
    this.scrolledNode = null
    this.scrollLeft = 0
  }
}
